'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VID = exports.VID = 'vid';
var UTK = exports.UTK = 'utk';
var ID = exports.ID = 'id';